import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnHint = _resolveComponent("KnHint")

  return (_openBlock(), _createBlock(_component_KnHint, {
    title: 'kpi.kpiScheduler.title',
    hint: 'kpi.kpiScheduler.hint'
  }, null, 8, ["title", "hint"]))
}